import { useQuery } from "react-query";
import {
  getActiveConfieEmployeeCount,
  getAllEmployees,
  getOnLeaveConfieEmployeeCount,
} from "../../../../../actions/Employees";

const useGetOnLeaveConfieEmployeeCount = () => {
  return useQuery(
    "GetOnLeaveConfieEmployeeCount",
    getOnLeaveConfieEmployeeCount,
    {
      refetchOnWindowFocus: false,
    }
  );
};

export default useGetOnLeaveConfieEmployeeCount;
